import './horizontalGoldEgg.scss';
import './verticalGoldEgg.scss';
import goldEggTpl from './goldEgg.ejs';
import goldEggSuccessTpl from './goldEgg-success.ejs';
import goldEggFailTpl from './goldEgg-fail.ejs';
import Event from '../eventBus';

import {Transform, RAF} from 'f.component.util';

class goldEgg{
    constructor({orientation = 'vertical'}) {
        this.orientation = orientation;

        this.boxDom = null;  // 总容器
        this.eggBoxDom = null; // 蛋容器
        this.selectDom = null;
        this.btn = null; // 发送按钮
        this.successDom = null; // 成功窗口容器
        this.failDom = null; // 失败窗口容器
        this.currentEggData = { // 当前金蛋信息
            id: null,
            price: 0,
            countdown: null
        }

        this.state = 'hide';
        this.Timer = null;

        this.width = document.documentElement.clientWidth;
        this.height = document.documentElement.clientHeight;
        this.boxDomHeight = null;
        this.event = Event;
        this.init()
    }

    init(presentInfo) {
        this.initDom();
        this.initEvent();
        this.initCustomEvent();
    }

    initDom(presentInfo) {

        this.boxDom = $(this.renderGoldEggTpl());
        this.moneyDom = this.boxDom.find('.money');
        this.sprinkleDom = this.boxDom.find('.money-sprinkle');
        this.eggBoxDom = this.boxDom.find('.egg-box');
        this.eggUpDom = this.boxDom.find('.egg-up');
        this.btnDom = this.boxDom.find('.btn');
        this.successDom = $(this.renderGoldEggSuccessTpl());
        this.failDom = $(this.renderGoldEggFailTpl());

        $('body').append(this.boxDom);
        $('body').append(this.successDom);
        $('body').append(this.failDom);

        this.boxDomHeight = this.boxDom.height();
        this.eggDomWidth = this.eggBoxDom.width();
        this.eggDomHeight = this.eggBoxDom.height();

        // Transform(this.boxDom[0]);
        // Transform(this.eggBoxDom[0]);
    }

    renderGoldEggTpl() {
        return goldEggTpl();
    }

    renderGoldEggSuccessTpl() {
        return goldEggSuccessTpl();
    }

    renderGoldEggFailTpl() {
        return goldEggFailTpl();
    }

    initEvent() {
        this.bindBtnEvent();
        this.bindHideEvent();
    }

    initCustomEvent() {
        this.event.on('orientation', this.setOrientation.bind(this));
        this.event.on('recieve-goldEggData', this.receiveGoldEggData.bind(this));
    }

    setOrientation(orientation) {
        this.orientation = orientation;
    }

    receiveGoldEggData(data) {
        console.log(data)
        if(!data || !data.id) {
            return ;
        }

        this.currentEggData = data;
        this.enter();
    }

    bindBtnEvent() {
        this.boxDom.on('touchend', () => {
            clearTimeout(this.Timer);
            this.Timer = null;
            this.showResult();
            this.event.trigger('send-goldEggData', {id:this.currentEggData.id});
            return false;
        })
    }

    hideDom() {
        this.boxDom.hide();
        this.successDom.hide();
        this.failDom.hide();
        return false;
    }

    bindHideEvent() {
        this.successDom.on('touchend', this.hideDom.bind(this));
        this.failDom.on('touchend', this.hideDom.bind(this));
    }

    showResult() {
        var _this = this;
        this.showMoney()
        .then(() => {
            if(this.currentEggData.price > 0) {
                return this.successResult();
            } else {
                return this.failResult();
            }
        })
        .then(() => {
            setTimeout(() => {
                this.end()
            }, 5000)
        })
        .catch((err) => console.log(err));
    }

    successResult() {
        return new Promise((resolve, reject) => {
            this.successDom.find('.js_num').text(this.currentEggData.price);
            this.successDom.show().addClass('animated zoomIn');
            setTimeout(() => {
                this.successDom.removeClass('animated zoomIn');
                resolve(1);
            }, 1000)
        })
    }

    failResult() {
        return new Promise((resolve, reject) => {
            this.failDom.show().addClass('animated zoomIn');
            setTimeout(() => {
                this.failDom.removeClass('animated zoomIn');
                resolve(1);
            }, 1000)
        })
    }

    end() {
        this.boxDom.hide();
        this.successDom.hide();
        this.failDom.hide();
        this.eggUpDom.css({opacity:1});
        this.sprinkleDom.css({opacity:0});
    }

    showMoney() {
        return new Promise((resolve, reject) => {
            this.eggUpDom.animate({opacity: 0}, 500, () => {
                this.sprinkleDom.show().animate({opacity: 1}, 500, resolve)
            })
        })
    }

    countDown(seconds) {
        this.Timer = null;
        this.Timer = setTimeout(() => {
            this.boxDom.hide();
            clearTimeout(this.Timer);
            this.Timer = null;
        }, seconds * 1000)
    }

    rotateEgg() {
        this.eggBoxDom.addClass('animated wobble')
        setTimeout(() => {
            this.eggBoxDom.removeClass('animated wobble')
        }, 1000)
    }

    enter(orientation = this.orientation) {

        this.resetStatus();

        this.boxDom.removeClass('animated slideInDown')
        
        // this.boxDom.show().animate({translateY: this.height / 2 + this.boxDomHeight}, 500, this.rotateEgg.bind(this));
        if(orientation == 'vertical') {
            this.boxDom.show().addClass('animated slideInDown slideIn')
        } else if(orientation == 'horizontal') {
            this.boxDom.show().addClass('animated slideInDown slideIn')
        }

        setTimeout(() => {
            this.boxDom.removeClass('animated slideInDown')
        }, 1000)

        this.countDown(this.currentEggData.countdown);
    }

    leave(orientation = this.orientation) {
        if(orientation == 'vertical') {
            
        } else if(orientation == 'horizontal') {
            
        }
    }

    resetStatus() {
        this.boxDom[0].translateY = 0;
        this.eggUpDom.css({'opacity': 1}).show();
        this.sprinkleDom.css({'opacity': 0}).hide();
    }

}

export default goldEgg;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/goldEgg/goldEgg.js